/**
 * Persist Chat Test UI transcript across route changes (sessionStorage).
 * Redis remains source of truth when available; cache covers empty/lagging responses.
 */
import type { ChatHistoryMessage, UserMessage } from '../components/chat-test/ChatHistory';

const PREFIX = 'agentstation_chat_test_transcript_v2:';

export interface ChatTestTranscriptCache {
  conversationId: string;
  history: ChatHistoryMessage[];
  userMessages: UserMessage[];
  nextOrder: number;
}

export function saveChatTestTranscript(scopeKey: string, data: ChatTestTranscriptCache): void {
  try {
    sessionStorage.setItem(PREFIX + scopeKey, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export function loadChatTestTranscript(scopeKey: string): ChatTestTranscriptCache | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + scopeKey);
    if (!raw) return null;
    const o = JSON.parse(raw) as ChatTestTranscriptCache;
    if (!o || typeof o.conversationId !== 'string') return null;
    if (!Array.isArray(o.history) || !Array.isArray(o.userMessages)) return null;
    if (typeof o.nextOrder !== 'number') return null;
    return o;
  } catch {
    return null;
  }
}

export function clearChatTestTranscript(scopeKey: string): void {
  try {
    sessionStorage.removeItem(PREFIX + scopeKey);
  } catch {
    /* ignore */
  }
}
